module.exports = __webpack_public_path__ + "img/R531.5276cb58.svg";